// extracted by mini-css-extract-plugin
export default {"root":"VerifiedBadge_root__O+a0J","trustNote":"VerifiedBadge_trustNote__GW4CT"};